// LocalStorage returns the current browser window's persistent storage.
export const LocalStorage = () => {
  let storagePersistent = window.localStorage;
  if (storagePersistent) { // Test if storage works
    try {
      storagePersistent.getItem('test_key');
    } catch (e) {
      // If accessing storage causes an error, disable it.
      console.debug('Local storage appears to be disabled or broken: ', e);
      storagePersistent = false;
    }
  }

  return storagePersistent;
};
